import { textSelector, huntNameSelector, regionNameSelector, patchNameSelector, permissionDescription, spawnCondition } from "assets/selector/language";
import { extractWorldInfo } from "sessions/gameInfo";
import { UserProfile } from "sessions/userState";

import { SocketIO } from "./socket";
import axios from "axios";

import SweetAlert from "react-bootstrap-sweetalert";
import { HuntTimers } from "sessions/databaseStorage"
import { aetheryteNameSelector } from "assets/selector/language";

const ERRORCODE = {
    "500": "Account not Logged In",
    "501": "Account not verified",
    "502": "User has no permission",
    
    "303": "Target User not Found",
    "304": "No permission over target datacenter",

    "201": "Train Not Found"
}

export var SessionConfigs = (function () {

    var language = "";
    var darkMode = !document.body.classList.contains("white-content");
    var dataCenter = "";
    var synced = false;
    var audioPermission = false;
    var audioVolume = 0.5;
    var browserNotification = {};
    var server = "https://tracker-api.beartoolkit.com";
    //var server = "http://localhost:4001";
    var csrfToken = "";

    var srankConfig = {};
    var arankConfig = {};
    var scheduleConfig = {};
    var fateConfig = {};

    const syncSession = async () => {
        try {
            const response = await axios.get(server + "/api/getSessionConfigs", {
                withCredentials: true
            });
            setConfigs(response.data.session);
            UserProfile.setUser(response.data.user);
            return true
        } catch (err) {
            console.log(err)
        }
        return false;
    }

    const setConfigs = (configs) => {
        language = configs.language;
        if (darkMode != configs.darkMode) {
            document.body.classList.toggle("white-content");
            darkMode = configs.darkMode;
        }
        browserNotification = configs.browserNotification;
        if (!browserNotification.customized) {
            browserNotification.customized = {};
        }

        darkMode = configs.darkMode;
        audioPermission = configs.audioPermission;
        audioVolume = configs.audioVolume;
        dataCenter = configs.datacenter;
        SocketIO.setRoomID(dataCenter);
        srankConfig = configs.srank;
        arankConfig = configs.arank;
        scheduleConfig = configs.schedule;
        fateConfig = configs.fate;

        HuntTimers.setHideDeadHunts("srank", configs.hideHunts.srank);
        HuntTimers.setHideDeadHunts("arank", configs.hideHunts.arank);
        
        synced = true;
    };

    const getConfigs = () => {
        return {
            srankConfig: srankConfig,
            arankConfig: arankConfig,
            scheduleConfig: scheduleConfig,
            fateConfig: fateConfig,
            language: language,
            darkMode: darkMode,
            dataCenter: dataCenter,
            audioPermission: audioPermission,
            audioVolume: audioVolume,
            browserNotification: browserNotification,
            user: UserProfile.getUser()
        }
    };

    const getToggleStates = (rankType) => {
        if (rankType == "srank") return srankConfig;
        if (rankType == "arank") return arankConfig;
        if (rankType == "schedule") return scheduleConfig;
        
        return {
            srankConfig: srankConfig,
            arankConfig: arankConfig,
            scheduleConfig: scheduleConfig,
            fateConfig: fateConfig,
        }
    };

    const setWorldSelect = (type, world, state) => {
        if (type == "srank") {
            srankConfig["world"][world] = state;
        } else if (type == "arank") {
            arankConfig["world"][world] = state;
        } else if (type == "schedule") {
            scheduleConfig["world"][world] = state;
        } else if (type == "fate") {
            fateConfig["world"][world] = state;
        } else {
            return;
        }
        queryData("/api/sessionUpdate", {
            UpdateToggle: "world",
            Type: type,
            Parameter: world,
            State: state,
        });
    };

    const setWorldSelectOnly = async (type, world) => {
        const worlds = Object.keys(srankConfig["world"]);
        for (var i = 0; i < worlds.length; i++) {
            if (type == "srank") {
                srankConfig["world"][worlds[i]] = worlds[i] == world;
            } else if (type == "arank") {
                arankConfig["world"][worlds[i]] = worlds[i] == world;
            } else if (type == "schedule") {
                scheduleConfig["world"][worlds[i]] = worlds[i] == world;
            } else if (type == "fate") {
                fateConfig["world"][worlds[i]] = worlds[i] == world;
            } else {
                return;
            }
        }
        await queryData("/api/sessionUpdate", {
            BulkUpdateToggleOFF: "world",
            Type: type,
            Parameter: world,
        });
    };

    const setPatchSelect = (type, patch, state) => {
        if (type == "srank") {
            srankConfig["patch"][patch] = state;
        } else if (type == "arank") {
            arankConfig["patch"][patch] = state;
        } else if (type == "schedule") {
            scheduleConfig["patch"][patch] = state;
        } else if (type == "fate") {
            fateConfig["patch"][patch] = state;
        }
        queryData("/api/sessionUpdate", {
            UpdateToggle: "patch",
            Type: type,
            Parameter: patch,
            State: state,
        });
    };

    const setPatchSelectOnly = (type, patch) => {
        const patches = Object.keys(srankConfig["patch"]);
        for (var i = 0; i < patches.length; i++) {
            if (type == "srank") {
                srankConfig["patch"][patches[i]] = patches[i] == patch;
            } else if (type == "arank") {
                arankConfig["patch"][patches[i]] = patches[i] == patch;
            } else if (type == "schedule") {
                scheduleConfig["patch"][patches[i]] = patches[i] == patch;
            } else if (type == "fate") {
                fateConfig["patch"][patches[i]] = patches[i] == patch;
            } else {
                return;
            }
        }
        queryData("/api/sessionUpdate", {
            BulkUpdateToggleOFF: "patch",
            Type: type,
            Parameter: patch,
        });
    };

    const setInstanceSelect = (type, instance, state) => {
        if (type == "arank") {
            arankConfig["instance"][instance] = state;
        }
        queryData("/api/sessionUpdate", {
            UpdateToggle: "instance",
            Type: type,
            Parameter: instance,
            State: state,
        });
    };

    
    const setHideDeadHunts = (type, state) => {
        queryData("/api/sessionUpdate", {
            UpdateHideHunt: type,
            State: state
        });
    }

    const setLanguage = (lang) => {
        language = lang;
        queryData("/api/sessionUpdate", {
            UpdateLanguageSelection: lang,
        });
    };

    const setDarkMode = () => {
        darkMode = !darkMode;
        document.body.classList.toggle("white-content");
        queryData("/api/sessionUpdate", {
            UpdateDarkMode: true,
            State: darkMode,
        });
    };

    const setAudioPermission = (state) => {
        audioPermission = state;
        queryData("/api/sessionUpdate", {
            UpdateAudioPermission: true,
            State: state,
        });
    };

    const setAudioVolume = (value) => {
        audioVolume = value;
        queryData("/api/sessionUpdate", {
            UpdateAudioVolume: true,
            State: value,
        });
    };

    const setNotification = (notification) => {
        browserNotification.customized = notification;
        queryData("/api/sessionUpdate", {
            UpdateNotification: true,
            State: browserNotification,
        });
    }

    const setDataCenter = async (name) => {
        dataCenter = name;
        SocketIO.setRoomID(name);
        return queryData("/api/sessionUpdate",{
            UpdateDataCenterSelection: name,
        })
    }

    const dictionaryLookup = (type, key) => {
        try {
            if (type == "header") {
                return textSelector[key][language];
            } else if (type == "huntName") {
                if (key.endsWith(" 1") || key.endsWith(" 2") || key.endsWith(" 3") || key.endsWith(" 4") || key.endsWith(" 5") || key.endsWith(" 6") || key.endsWith(" 7") || key.endsWith(" 8")) {
                    const baseName = key.slice(0,-2);
                    return huntNameSelector[baseName][language] + key.slice(-2);
                } else {
                    return huntNameSelector[key][language];
                }
            } else if (type == "regionName") {
                return regionNameSelector[key][language];
            } else if (type == "patchName") {
                return patchNameSelector[key][language];
            } else if (type == "description") {
                return spawnCondition[key][language];
            } else if (type == "permission") {
                return permissionDescription[key][language];
            } else if (type == "aetheryteName") {
                return aetheryteNameSelector[key][language];
            }
        } catch (error) {
            console.log(error);
            return key;
        }
    }

    const getLanguage = () => {
        return language;
    }

    const getDarkMode = () => {
        return darkMode;
    }

    const getDataCenter = () => {
        return dataCenter;
    }

    const getAudioPermission = () => {
        return audioPermission;
    }

    const getAudioVolume = () => {
        return audioVolume;
    }

    const getWorldsOfDataCenter = (newDC) => {
        return extractWorldInfo(newDC ? newDC : dataCenter);
    }

    const isSynced = () => {
        return synced;
    }

    const queryData = (url, form) => {
        return axios.post(server + url, form, {
            withCredentials: true
        });
    }

    const displayError = (error, setAlert) => {
        if (error.response) {
            if (error.response.status === 400) {
                if (Object.keys(ERRORCODE).includes(error.response.data.code)) {
                    setAlert(
                        <SweetAlert
                            error style={{display: "block", marginTop: "-100px"}}
                            title="ERROR"  onConfirm={() => setAlert(null)}
                            onCancel={() => setAlert(null)} confirmBtnBsStyle="info" >
                              {ERRORCODE[error.response.data.code]}
                        </SweetAlert>
                      );
                } else if (error.response.data.message) {
                    setAlert(
                        <SweetAlert
                            error style={{display: "block", marginTop: "-100px"}}
                            title="ERROR"  onConfirm={() => setAlert(null)}
                            onCancel={() => setAlert(null)} confirmBtnBsStyle="info" >
                              {error.response.data.message}
                        </SweetAlert>
                      );
                } else {
                    setAlert(
                        <SweetAlert
                            error style={{display: "block", marginTop: "-100px"}}
                            title="Response CODE"  onConfirm={() => setAlert(null)}
                            onCancel={() => setAlert(null)} confirmBtnBsStyle="info" >
                              {error.response.data.code}
                        </SweetAlert>
                      );
                }
            } else {
                <SweetAlert
                    error style={{display: "block", marginTop: "-100px"}}
                    title="Unknown Error"  onConfirm={() => setAlert(null)}
                    onCancel={() => setAlert(null)} confirmBtnBsStyle="info" >
                      {error.response.status}
                </SweetAlert>
            }
        } else {
            console.log(error)
        }
    }

    const uploadFile = (url, form) => {
        return axios.post(server + url, form, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            withCredentials: true
        });
    }

    const getData = (url) => {
        return axios.get(server + url, {
            withCredentials: true
        });
    }

    const authenticate = (userInfo) => {
        return queryData("/api/authenticate", {
            username: userInfo.username,
            password: userInfo.password
        });
    }

    const register = (userInfo, lodestoneID) => {
        if (lodestoneID) {
            return queryData("/api/register", {
                username: userInfo.username,
                password: userInfo.password,
                ingameID: userInfo.ingameID,
                ingameRegion: userInfo.idRegion ? "Global" : "CN"
            });
        } else {
            return queryData("/api/register", {
                username: userInfo.username,
                password: userInfo.password,
                ingameName: userInfo.ingameName,
                ingameServer: userInfo.ingameServer
            });
        }
    }

    return {
        syncSession: syncSession,
        isSynced: isSynced,
        authenticate: authenticate,
        register: register,

        setConfigs: setConfigs,
        getConfigs: getConfigs,
        getToggleStates: getToggleStates,
        setWorldSelect: setWorldSelect,
        setWorldSelectOnly: setWorldSelectOnly,
        setPatchSelect: setPatchSelect,
        setPatchSelectOnly: setPatchSelectOnly,
        setInstanceSelect: setInstanceSelect,
        setHideDeadHunts: setHideDeadHunts,
        
        setLanguage: setLanguage,
        setDarkMode: setDarkMode,
        setDataCenter: setDataCenter,
        setAudioPermission: setAudioPermission,
        setAudioVolume: setAudioVolume,
        setNotification: setNotification,

        dictionaryLookup: dictionaryLookup,
        
        getLanguage: getLanguage,
        getDarkMode: getDarkMode,
        getDataCenter: getDataCenter,
        getWorldsOfDataCenter: getWorldsOfDataCenter,
        getAudioPermission: getAudioPermission,
        getAudioVolume: getAudioVolume,

        queryData: queryData,
        displayError: displayError,
        getData: getData,
        uploadFile: uploadFile,
    }

})();
